import React from 'react';

import './blogs.css';
const Narendra_prajapat = () => {
    return (
    <div className="blog">
    <div className="row blog-row">
      <div className="col-md-4">
        <img
          src= "placement-postulates/blogs/Narendra-prajapat/1.jpg"
          style={{ height: "315px", width: "90%" }}
          alt="Narendra_prajapat"
        ></img>
      </div>
      <div className="col-md-8">
        <div className="blog-head">
          <h2>Narendra Prajapat</h2>
          <small> Futures First</small>
        </div>
      </div>
    </div>
    <div className="container-fluid">
      <div className="row blog-row">
        <div className="col-md-12">
          <h3>Introduction </h3>
          <p>
            Hi, I am Narendra Prajapat, a market analyst at Futures First.
            <br /> 
            For me, it was effective communication and confidence that made all the difference.
          </p>
        </div>
      </div>
      <img
        class="blog-image-right"
        src="placement-postulates/blogs/Narendra-prajapat/2.jpg"
        alt="Narendra_prajapat"
      />

      <div className="row blog-row">
        <div className="col-md-12">
          <h3>Importance of a Resume</h3>
          <p>
            Since I could not secure an on-campus internship in my third year
            (although I got one off-campus), I realized the importance of a 
            strong resume. Therefore, I ensured that my placement resume was
            relevant to different profiles. I submitted three one-page resumes:
            one for software/analytics, one for consulting/product management, 
            and one for finance profiles.
          </p>

          <p>
            Make sure your resume is reviewed by 5–10 seniors.
          </p>
        </div>
      </div>

      <div className="row blog-row">
        <div className="col-md-12">
          <h3>CPI Matters</h3>
          <p>
            The idea that CPI doesn’t matter is a myth; a good CPI will always
            give you an edge over others. With a good CPI, you will easily get
            shortlisted for many tests. Try to maintain a 7.5+ CPI to be eligible
            for almost every test. I wasn’t shortlisted for many companies, despite
            solving almost all questions in the coding round, just because of 
            a low CPI or branch cutoff. Don’t get frustrated; instead, focus on the 
            upcoming companies. Take all the tests without worrying about your chances
            of getting shortlisted. Be confident because there will be many opportunities.
          </p>
        </div>
      </div>
      <br />
      <br />
      <br />
      <img class="blog-image-right"
      src="placement-postulates/blogs/Narendra-prajapat/3.jpg"
      alt="Narendra_prajapat"
      />
      <div className="row blog-row">
        <div className="col-md-12">
          <h3> It's better to prepare for more than one profile.</h3>
          <p>
            Before the placements, I decided not to be selective for a 
            specific profile to apply for. So, I applied for nearly all
            kinds of profiles targeting SDE and PM roles. As the placement
            drive progressed, I was shortlisted for interviews with 
            Finmechanics (day 1.1), Battery Smart (day 2.2), Axxela (day 3.2),
            and FuturesFirst (day 4.2).
          </p>
        </div>
      </div>
      
      <div className="row blog-row">
        <div className="col-md-12">
          <h3>Coding Preparation</h3>
          <p>
            For preparation, I focused on LeetCode. I recommend solving
            more medium-level problems on LeetCode, as most companies’ 
            coding rounds are at that level. I watched a YouTube playlist 
            by Striver for topics like trees, graphs, and dynamic programming 
            (DP), which are tricky and frequently asked in interviews. 
            Additionally, I participated in Codeforces contests, 
            which helped me improve my problem-solving abilities, 
            especially with greedy problems.
          </p>
          
          <p>
            If your internship is remote or you are on campus in the summer,
            then do your preparation at NCL; it's the best place to study 
            without being disturbed by others, and use the resources given by IITK.
          </p>
        </div>
      </div>

      <div className="row blog-row">
        <div className="col-md-12">
          <h3>Puzzles</h3>
          <p>
            Go through puzzles on GeeksforGeeks. More than 90% of the puzzles 
            you’ll be asked in interviews will be the same or slight variations
            of these problems. Practice these puzzles repeatedly until you have 
            a clear understanding of their logic and can easily solve their 
            variations during interviews.
          </p>
          <p>
            Guesstimates and Case Studies
          </p>
          <p>
            An important aspect of interview preparation is not just reading 
            cases but understanding the approach for frameworks. Learn standard 
            frameworks, but don’t stick to them rigidly; some interview questions 
            may require you to form your own framework. Read one case from each 
            category, then practice solving cases as an interviewee with a friend 
            or senior acting as the interviewer.
          </p>
          <p>
            I used to do this at Mama Mio late at night while enjoying Maggi with 
            my friends. It became our daily routine, thanks to my friend Prince, 
            who was a foodie. (Some habits can have a very positive impact.)
          </p>
        </div>
      </div>
      <img class="blog-image-right"
      src="placement-postulates/blogs/Narendra-prajapat/4.jpg"
      alt="Narendra_prajapat" />
      <div className="row blog-row">
        <div className="col-md-12">
          <h3>Be in a positive environment <br/></h3>
          <p>
            In my case, my wingies were my backbone 
            (Prince, Yash, Hariom, Yasvir, Prabudhha, Mayank,
            Fahad, Akshunaya, and Jasjot), as there will be
            many ups and downs throughout the process. Having 
            friends who always motivate you is all you need 
            during the placement interview. In most cases, SPO 
            peeps will support you, but there will be cases 
            where SPO will just help their friends get placement, 
            so be prepared for that as well (try to ensure 
            that the process is fair enough). And at the end, chill to h hi.
          </p>
          <p>
            My entire wing stayed until the very last day, with most
            of us remaining on campus until the SPO deadline to support 
            those who hadn't secured placements by day ten.
            <br/>
            <br/>
            Regardless of what you are preparing for, remember that 
            knowledge and communication skills are all you need to clear 
            your path. 
            <br/>
            <br/>
            “Ek Company jarur aayegi aur tume le jayegi bas apne aap per confidence rakhna.” 
            <br/>
            <br/>
            Baaki, if you want any help, be it personal, academic, or career, 
            feel free to reach out. I’ll be more than happy to help.
          </p>
        </div>
      </div>
    </div>
  </div>
    );
};

export default Narendra_prajapat